(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sbDataLayer"));
	else if(typeof define === 'function' && define.amd)
		define("sbUserLib", ["sbDataLayer"], factory);
	else if(typeof exports === 'object')
		exports["sbUserLib"] = factory(require("sbDataLayer"));
	else
		root["sbUserLib"] = factory(root["sbDataLayer"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__) {
return 